import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  duration: number
}

const BreakDuration = ({ duration }: Props) => {
  const [open, toggle] = useToggle(false)
  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Tooltip.Alt
        attachment="bottom center"
        open={open}
        toggle={toggle}
        label={i18n.t('shift_management.planned_breaks.tooltips.duration')}
      >
        <Icon.Medium icon="clock" color="grey800" />
      </Tooltip.Alt>
      <Text size="100" color="grey1000">
        {i18n.t('shift_management.planned_breaks.duration', { duration })}
      </Text>
    </Box>
  )
}

export default observer(BreakDuration)
